import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ListItemText, MenuItem, Typography } from '@mui/material'
import { NavigateFunction, useNavigate } from 'react-router-dom'

// COMPONENT
import * as styled from '../../style/main.style'
import Header from '../../Header'
import Navbar from '../../Navbar'
import TableCustom from '../../../../component/table/tableCustom'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import HeaderTopicTable from '../../../../component/header-table/HeaderTopicTable'
import { RouteImage } from '../../../../assets/routeImage'
import { disableStyleButtonMui } from '../../../../utils/disableStyleButton'
import ModalCustom from '../../../../component/modal/ModalCustom'
import AddUsers from './add-users/AddUsers'
import EditUsers from './edit-users/EditUsers'
import FilterSelect from '../../../../component/select/filterSelect'
import { ButtonOutlined } from '../../../../component/mui-custom/MuiCustom'
import Loading from '../../../../component/loading/Loading'

// API
import { EmployeesApi, employeeType, updateEmployeesTypes } from '../../../../api/employee/Employees.api';

// STORE
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'
import { debouncedApiCall, formatPhoneNumberTh } from '../../../../utils/app.utils'
import InputTextField from '../../../../component/input/inputTextField'


const SystemUsers: React.FC = () => {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state.loading.isLoading)
    const permission = useSelector((state: any) => state?.permission?.permission)

    const [employees, setEmployees] = useState<any>(null);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [keyword, setKeyWord] = useState<string>("");
    const [toggleModalAdd, setToggleModalAdd] = useState<boolean>(false);
    const [toggleModalEdit, setToggleModalEdit] = useState<boolean>(false);
    const [employeeId, setEmployeeId] = useState<number>(Number);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }


    const handleToggleAddModal = () => setToggleModalAdd(!toggleModalAdd)
    const handleToggleEditModal = () => setToggleModalEdit(!toggleModalEdit)
    const handleSetEditEmployee = (employeeId: number) => {
        setEmployeeId(employeeId)
        handleToggleEditModal()
    }
    const handleChangeStatus = async (employeeId: number, status: string, objData: any) => {
        try {
            dispatch(setLoading())
            let condition: updateEmployeesTypes = {
                email: objData?.email,
                employeeFirstname: objData?.employeeFirstname,
                employeeLastname: objData?.employeeLastname,
                idDepartment: objData?.idDepartment,
                idPosition: objData?.idPosition,
                idRole: objData?.idRole,
                tel: objData?.tel,
                employeeStatus: status,
                fax: objData?.fax,
                title: objData?.title
            }
            await EmployeesApi.updateEmployee(employeeId, condition)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        console.log(res.data)
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
                .finally(() => handleGetEmployees())
        } catch (error) {
            console.log(error)
        }
    }


    const headCells = [
        {
            id: "RANK", disablePadding: false, align: 'center', width: 100, label: "ลำดับ"
        },
        {
            id: "employeeFirstname", disablePadding: true, width: 260, sortable: true, align: 'center', label: "ชื่อ - นามสกุล"
        },
        {
            id: "ROLE", disablePadding: true, align: 'center', width: 150, label: "บทบาท"
        },
        {
            id: "ROLE", disablePadding: true, align: 'center', width: 200, label: "โทรศัพท์"
        },
        {
            id: "ROLE", disablePadding: true, align: 'center', width: 200, label: "โทรสาร"
        },
        {
            id: "ROLE", disablePadding: true, align: 'center', width: 300, label: 'email'
        },
        {
            id: "ROLE", disablePadding: true, align: 'center', width: 150, label: "สถานะ"
        },
        {
            id: "EDIT", disablePadding: false, align: "left", class: true, width: 100, label: ""
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idEmployee, email, employeeFirstname, title, tel, fax, employeeLastname, role, employeeStatus } =
            objData;

        const objRenderData = {
            key: idEmployee,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                { option: "TEXT", align: "left", label: `${title}${employeeFirstname} ${employeeLastname}` || "-" },
                { option: "TEXT", align: "left", label: role?.roleName || "-" },
                { option: "TEXT", align: "center", label: formatPhoneNumberTh(tel || "") || "-" },
                { option: "TEXT", align: "center", label: fax || "-" },
                { option: "TEXT", align: "start", label: email || "-" },
                {
                    option: "TEXT", align: "center", label:
                        <FilterSelect
                            disabled={permission?.find((list: any) => list?.code === "SystemUsers.Edit")?.permit === false}
                            headingNormal
                            renderValue={() =>
                                <ListItemText className='relative'>
                                    {employeeStatus === t("STATUS.ACTIVE") ? (
                                        <Typography
                                            className='text-light_success after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                            {t("STATUS.ACTIVE")}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            className='text-danger after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                            {t("STATUS.INACTIVE")}
                                        </Typography>
                                    )}
                                </ListItemText>
                            }

                            label={t('STATUS.LABEL')}
                            selectId="select-fiscal-year"
                            value={employeeStatus}
                            labelId="label-fiscal-year"
                            onchange={(e) => handleChangeStatus(idEmployee, e.target.value, objData)}
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                                </MenuItem>
                            ]}
                        />
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    width: 10,
                    class: true,
                    component:
                        <div
                            className='w-full flex justify-end gap-5'>
                            {permission?.find((list: any) => list?.code === "SystemUsers.Edit")?.permit === true && (
                                <Button
                                    onClick={() => handleSetEditEmployee(idEmployee)}
                                    startIcon={<img src={RouteImage.editPen} />}
                                    sx={disableStyleButtonMui}>{"แก้ไข"}</Button>
                            )}
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleGetEmployees = useCallback(async () => {
        dispatch(setLoading())
        let condition: employeeType = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, limit: pageLimit }
        if (keyword) condition = { ...condition, keyword: keyword }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        await EmployeesApi.getEmployees(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setEmployees(res?.data?.result)
                    setTotalItems(res?.data?.result?.meta?.totalItems)
                    // console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit, keyword, sortBy, sortType])

    useEffect(() => {
        handleGetEmployees();
    }, [handleGetEmployees])

    useEffect(() => {
        const permissionCheck = permission?.find((list: any) => list?.code === "SystemUsers.Read")?.permit;
        if (permissionCheck === false) {
            navigate('/404');
        }
    }, [navigate])

    return (
        <styled.ContainerHome>
            {isLoading && <Loading />}
            <Navbar />
            {toggleModalAdd &&
                <ModalCustom
                    componentHeight={'600px'}
                    enableExit={handleToggleAddModal}
                    maxHeight='auto'
                    alignHeader='center'
                    heading='เพิ่มผู้ใช้งาน'
                    component={<AddUsers fetchData={handleGetEmployees} toggleModal={handleToggleAddModal} />}

                />}
            {toggleModalEdit &&
                <ModalCustom
                    componentHeight='600px'
                    enableExit={handleToggleEditModal}
                    maxHeight='500px'
                    alignHeader='center'
                    heading='แก้ไขข้อมูล'
                    component={<EditUsers employeeId={employeeId} fetchData={handleGetEmployees} toggleModal={handleToggleEditModal} />}

                />}

            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader
                        sx={{ mb: 1 }}
                    >
                        <Typography variant='h4'>
                            {"จัดการผู้ใช้งาน"}
                        </Typography>
                        {permission?.find((list: any) => list?.code === "SystemUsers.Create")?.permit === true && (
                            <ButtonOutlined
                                onClick={handleToggleAddModal}
                                sx={{ maxWidth: 100 }}
                                startIcon={<img src={RouteImage.addButton} />}>
                                <Typography className='text-primary'> {t("BUTTON.ADD")}</Typography>
                            </ButtonOutlined>
                        )}
                    </styled.TopicHeader>
                    <section className='grid grid-cols-12'>
                        <article className='col-span-12 md:col-span-3 lg:col-span-3'>
                            <InputTextField
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    debouncedApiCall({
                                        searchItem: e.target.value, setItem: setKeyWord
                                    })
                                    setPage(1)
                                }}
                                heading='ค้นหา'
                            />
                        </article>
                    </section>
                    <section className='mt-8 w-full h-auto'>
                        {employees && (
                            <TableCustom
                                customScroll
                                tableFixedWidth
                                tableMinWidth={1440}
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                onSort={handleRequestSort}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={employees?.items?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default SystemUsers